import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Parser from "html-react-parser";
import http from "../http";
import Obra from "./Obra";
import { Breadcrumb } from "./Breadcrumb";
import BtnBack from "./BtnBack";
import Nota from "./Nota";

const Sujeto = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [sujeto, setSujeto] = useState({});
  const [categorias, setCategorias] = useState([]);
  const { id } = useParams();
  const navigate = useNavigate();
  const [mpiosLeyenda1] = useState(["chikindzonot","quintana-roo","yobain"]);
  const [mpiosLeyenda2] = useState(["baca","bokoba","cacalchen","cenotillo","cuzama","chochola","dzan","maxcanu","opichen","oxkutzcab","sacalum","sotuta","tekax","telchac-pueblo","temax","tetiz","teya","tixcacalcupul","tixmehuac","yaxcaba"]);
  // const anio = 2025;

  useEffect(() => {
    const getSujeto = async () => {
      setIsLoading(true);
      await http.get("/sujeto-obligado/" + id + "/2025").then((resp) => {
        const data = resp.data;
        if (
          data === "Error sujeto incorrecto" ||
          data === "Error sujeto no proporcionado"
        ) {
          navigate("/");
        }
        setIsLoading(false);
        setSujeto(data.sujeto);
        setCategorias(data.categorias);
      });
    };
    getSujeto();
  }, []);

  const date = Date.now();

  return (
    <>
      {isLoading ? (
        <p className="fs-4 mt-5">Espera....</p>
      ) : (
        <div className="about_content-two mt-5 my-5">
          <Breadcrumb current={sujeto.nombre} />
          <h3 className="text-center">{sujeto.nombre}</h3>
          {
            mpiosLeyenda1.includes(id) && (
              <h5 className="mt-4 fst-italic text-center mb-4">
                Este Sujeto Obligado no presentó su listado preliminar de políticas públicas y actos gubernamentales considerados como trascendentales de conformidad con los términos establecidos en el Artículo 11 de la Ley de Participación Ciudadana que regula el Plebiscito, Referéndum y la Iniciativa Popular en el Estado de Yucatán.
              </h5>
            )
          }
          {
            mpiosLeyenda2.includes(id) && (
              <h5 className="mt-4 fst-italic text-center mb-4">
                Este Sujeto Obligado cumplió con la presentación de su lista con la precalificación de sus propios actos de conformidad con los Artículos 11 y 28 de la Ley de Participación Ciudadana que regula el Plebiscito, Referéndum y la Iniciativa Popular en el Estado de Yucatán; sin embargo, estas no fueron calificadas como trascendentes de conformidad con el artículo 16 de la propia Ley.
              </h5>
            )
          }

          <div className="row">
            <div className="col-md-10">
              {
              // sujeto.id !== 2 || (sujeto.id == 2 && anio === 2025 ) ? 
              (
                 categorias.map((categoria, index) => (
                  
                  categoria.obras.length > 0 &&
                  (
                    <div key={index}>
                      <p className="fs-18">
                        <b>{categoria.nombre}</b>
                      </p>
                      <Obra obras={categoria.obras} sujeto={sujeto.id} />
                    </div>
                  ) 
                  
                ))
              ) 
              // : (
              //   <p className="fs-18">{Parser(categorias)}</p>
              // )
              }

              {/* {mpiosLeyenda.includes(id) && <Nota mpio={id} />} */}

              
            </div>

            
            <div className="col-md-2">
              <div className="row">
                <div className="col-sm-12">
                  <a
                    href={
                      "https://iepac.mx/catalogo-de-politicas-publicas-2026.pdf?r=" +
                      date
                    }
                    rel="noreferrer"
                    target="_blank"
                  >
                    <img
                      src={require("../assets/descarga-catalogo-2026.png")}
                      className="img-fluid mb-5"
                      alt="¿Cómo solicito un plebiscito?"
                    />
                  </a>
                </div>
                <div className="col-sm-12 mb-3">
                  <Link
                    to={process.env.PUBLIC_URL + "/como-solicito-un-plebiscito"}
                  >
                    <img
                      src={require("../assets/como-solicito-un-plebiscito.png")}
                      className="img-fluid"
                      alt="¿Cómo solicito un plebiscito?"
                    />
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <BtnBack />
        </div>
      )}
    </>
    // </ObraProvider>
  );
};

export default Sujeto;
